import { differenceInDays, endOfYear, startOfYear, format, intervalToDuration } from 'date-fns';
import { TFunction } from 'i18next';

export class DateUtil {
  public static daysDifferenceInCurrentYear = (): number => {
    const yearEnd = endOfYear(new Date());
    const yearStart = startOfYear(new Date());
    return differenceInDays(yearEnd, yearStart) + 1;
  };

  public static formatTimeZoneAgnosticDate = (date: string): string => {
    const timezoneRegex = /(\+|-)(\d{2}):(\d{2})$/;

    if (!isNaN(Date.parse(date))) {
      if (date.includes('Z')) {
        const dateWithoutZ = date.substring(0, date.length - 1);
        const formattedDate = format(new Date(dateWithoutZ), 'dd/MM/yyyy HH:mm:ss');
        return `${formattedDate}Z`;
      } else if (timezoneRegex.test(date)) {
        const dateWithoutTimezone = date.replace(timezoneRegex, '');
        const formattedDate = format(new Date(dateWithoutTimezone), 'dd/MM/yyyy HH:mm:ss');
        const timezone = date.slice(-6);
        return `${formattedDate} ${timezone}`;
      } else {
        return format(new Date(date), 'dd/MM/yyyy HH:mm:ss');
      }
    } else {
      return '';
    }
  };

  public static getHumanReadableDuration = (duration: string | null, t: TFunction): string => {
    //duration is ISO 8601 Duration
    if (!duration) return '';
    const match = duration.match(/^P(?:(\d+)Y)?(?:(\d+)M)?(?:(\d+)D)?$/);
    if (!match) return '';

    const years = parseInt(match[1] || '0', 10);
    const months = parseInt(match[2] || '0', 10);
    const days = parseInt(match[3] || '0', 10);

    return [
      years ? t('duration_years', { count: years }) : '',
      months ? t('duration_months', { count: months }) : '',
      days ? t('duration_days', { count: days }) : '',
    ]
      .filter(Boolean)
      .join(', ');
  };

  public static getHumanReadableDurationFromSeconds = (
    seconds: number | null | undefined,
    t: TFunction
  ): string => {
    if (!seconds || seconds <= 0) return '';
    const duration = intervalToDuration({ start: 0, end: seconds * 1000 });

    return [
      duration.years ? t('duration_years', { count: duration.years }) : '',
      duration.months ? t('duration_months', { count: duration.months }) : '',
      duration.days ? t('duration_days', { count: duration.days }) : '',
      duration.hours ? t('duration_hours', { count: duration.hours }) : '',
      duration.minutes ? t('duration_minutes', { count: duration.minutes }) : '',
      duration.seconds ? t('duration_seconds', { count: duration.seconds }) : '',
    ]
      .filter(Boolean)
      .join(', ');
  };
}
